import '.e1{font-size:1.125rem;}.ssr-plugin'
import '.e6{line-height:1.75rem;}.ssr-plugin'
import '.eh{text-decoration:none;}.ssr-plugin'
import '.fu{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e1 e6"
    >
      {translations.privacySubtitle}{' '}
      <a className="eh fu"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="eh fu"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
